import { statusLabel } from "../lib/format";

export function StatusPill({
  status,
  stage
}: {
  status: string;
  stage?: string;
}) {
  const tone =
    status === "ready"
      ? "ready"
      : status === "failed"
        ? "failed"
        : status === "canceled"
          ? "muted"
          : "working";
  return (
    <span className={`status-pill status-${tone}`}>
      <i aria-hidden="true" />
      {statusLabel(status, stage)}
    </span>
  );
}

